import { Action } from '@ngrx/store';
import { BusinessLine } from '@cemex-core/cmx-api/models/business-lines/business-line';

export enum OneClickBusinessLinesActionTypes {
  LOAD = '[One Click] Load business lines',
  LOAD_COMPLETE = '[One Click] Load business lines completed',
  LOAD_ERROR = '[One Click] Error Load Business lines',
  SELECT = '[One Click] Select business line',
  RESET = '[One Click] Business lines reset',
}

export class OneClickLoadBusinessLinesAction implements Action {
  readonly type = OneClickBusinessLinesActionTypes.LOAD;

  constructor(public payload?: string) {}
}

export class OneClickLoadBusinessLinesCompleteAction implements Action {
  readonly type = OneClickBusinessLinesActionTypes.LOAD_COMPLETE;

  constructor(public payload: BusinessLine[]) {}
}

export class OneClickSelectBusinessLinesAction implements Action {
  readonly type = OneClickBusinessLinesActionTypes.SELECT;

  constructor(public payload: BusinessLine) {}
}

export class OneClickErrorLoadBusinessLinesAction implements Action {
  readonly type = OneClickBusinessLinesActionTypes.LOAD_ERROR;

  constructor(public payload: any) {}
}

export class OneClickResetBusinessLinesAction implements Action {
  readonly type = OneClickBusinessLinesActionTypes.RESET;

  constructor() {}
}

export type OneClickBusinessLinesActions =
  | OneClickLoadBusinessLinesAction
  | OneClickLoadBusinessLinesCompleteAction
  | OneClickSelectBusinessLinesAction
  | OneClickErrorLoadBusinessLinesAction
  | OneClickResetBusinessLinesAction;
